import React from 'react'

const M20Copy = ({ heading, copy, anchorLinkId }) => (
  <section className="my-10 md:my-20" id={anchorLinkId}>
    <div className="container">
      <div className="row-type-g">
        <div className="col-1-type-g4">
          <h1 className="u-h1 mb-7">{heading}</h1>
          <div
            className="max-w-full prose link-wrapper"
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        </div>
      </div>
    </div>
  </section>
)

export default M20Copy
